import { NavigationLink } from "components/base/base.js";

export const LeftButtons = () => (
  <div className="flex space-x-4">
    <NavigationLink to="/products/index" title="Products" />
    <NavigationLink to="/products/warnings" title="Warnings" />
    <NavigationLink to="/products/export" title="Export All" />
  </div>
);

export const RightButtons = () => <div className="flex space-x-4"></div>;
